import { faEnvelopes, faMoneyBillWave, faTag } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as GivebutterPlusSplash from 'components/givebutter-plus-splash/GivebutterPlusSplash';
import WorkflowsSplash from 'images/workflows-splash.webp';

const WorkflowsGivebutterPlusSplashPage = () => {
    return (
        <GivebutterPlusSplash.Root>
            <GivebutterPlusSplash.Content>
                <GivebutterPlusSplash.Header>
                    <GivebutterPlusSplash.Text>
                        <GivebutterPlusSplash.HeaderLogo />
                        <GivebutterPlusSplash.Title>Workflows</GivebutterPlusSplash.Title>
                        <GivebutterPlusSplash.Description>
                            Simplify your communications and donor relations with Workflows!
                            Automate reaching out to donors, tagging event attendees, sending
                            cheerful birthday messages, and so much more!
                        </GivebutterPlusSplash.Description>
                        <GivebutterPlusSplash.CallToAction />
                    </GivebutterPlusSplash.Text>
                    <GivebutterPlusSplash.HeaderImage>
                        <img src={WorkflowsSplash} alt="Workflows illustration" />
                    </GivebutterPlusSplash.HeaderImage>
                </GivebutterPlusSplash.Header>
                <GivebutterPlusSplash.FeatureCardRow>
                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-1">
                            <FontAwesomeIcon icon={faEnvelopes} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Automate emails and texts
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Send emails and text when donors give money, bid on auction items
                                and more.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-2">
                            <FontAwesomeIcon icon={faTag} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                CRM contact tagging
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Automatically tag and organize your contacts based on actions they
                                perform.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-3">
                            <FontAwesomeIcon icon={faMoneyBillWave} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                First time donor outreach
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Automate outreach to first-time donors to establish a relationship.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>
                </GivebutterPlusSplash.FeatureCardRow>
                <GivebutterPlusSplash.Footer />
            </GivebutterPlusSplash.Content>
        </GivebutterPlusSplash.Root>
    );
};

export { WorkflowsGivebutterPlusSplashPage };
